import OrchestratorAPI from './common.js';
import {
  type CanonicalField,
  type CreateValues,
  type FindAllOptions,
  type VerifyResult,
  type VerifyRow,
} from '../models/orchestrator/canonicalField.js';
import { type PaginatedQueryOptions } from '../models/pagination/PaginatedQueryOptions.type.js';
import { type PaginationResponse } from '../models/pagination/PaginationResponse.type.js';

export default class API extends OrchestratorAPI {
  protected readonly API_PATH = '/canonical-fields';
  public readonly baseEndpoint = `${this.BASE_URL}${this.API_PATH}`;

  async findAll(options?: FindAllOptions): Promise<CanonicalField[]> {
    const url = this.constructPath('/', options);
    const { canonicalFields } = await this.common.getJSON(url);
    return canonicalFields ? canonicalFields.map(this.deserialize) : [];
  }

  async findOneById(id: string): Promise<CanonicalField> {
    const url = this.constructPath(`/${id}`);
    const { canonicalField } = await this.common.getJSON(url);
    return canonicalField;
  }

  async findAllPaginated(
    options: PaginatedQueryOptions<FindAllOptions>
  ): Promise<PaginationResponse<CanonicalField>> {
    const url = this.constructPath('/', options);
    return await this.common.getJSON(url);
  }

  async create(values: CreateValues): Promise<CanonicalField> {
    const url = this.constructPath('/');
    const { canonicalField } = await this.common.postJSON(url, values);
    return this.deserialize(canonicalField);
  }

  async bulkUpsert(values: CreateValues[]): Promise<CanonicalField[]> {
    const url = this.constructPath('/');
    const { canonicalField } = await this.common.putJSON(url, values);
    return canonicalField ? canonicalField.map(this.deserialize) : [];
  }

  async verify(rows: VerifyRow[]): Promise<VerifyResult> {
    const url = this.constructPath('/verify');
    return await this.common.postJSON(url, rows);
  }
}
